<div *ngIf="windowScrolled" class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
  <div (click)="scrollToTop()" class="flex-display cursor-pointer backToTopMargin font-14-imp">
    <div class="links pt-12px singleLine cursor-pointer text-decoration-none">{{backToTop}}</div> <div>&nbsp;</div>
    <div class="icon-text arrowButton">
      <mat-icon class="colorWhite">arrow_upward</mat-icon>
    </div>
  </div>
</div>
